import isObject from "lodash/isObject";
import { isEventTarget, getEffectTarget } from "@lilib/utils";
import usePersist from "./usePersist";
import useTargetEffect from "./useTargetEffect";
function useEventListener(target, eventName, listener, options) {
  var capture;
  var once;
  var passive;
  if (typeof options === "boolean") {
    capture = options;
  } else if (isObject(options)) {
    if (options.capture !== undefined) {
      capture = !!options.capture;
    }
    if (options.once !== undefined) {
      once = !!options.once;
    }
    if (options.passive !== undefined) {
      passive = !!options.passive;
    }
  }
  var handler = usePersist(listener);
  useTargetEffect(function () {
    var element = getEffectTarget(target);
    if (isEventTarget(element)) {
      element.addEventListener(eventName, handler, {
        capture: capture,
        once: once,
        passive: passive
      });
      return function () {
        element.removeEventListener(eventName, handler, {
          capture: capture
        });
      };
    }
  }, [eventName, capture, once, passive], [target]);
}
export default useEventListener;